// Dependencies
import React from 'react';
import radium from 'radium';

import Image from '../pp-order-successful/Image.jsx';
import SocialNetworks from '../../../components/socialNetworks/SocialNetworks.jsx';
import ButtonEventsOverview from '../../../components/button-events-overview/ButtonEventsOverview.jsx';
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import SponsorLogos from "../pp-order-successful/SponsorLogos";
import { connect } from "react-redux";
import fbPixelService from "../../../lib/fbPixel-service";

class CHECKOUT_SUCCESS extends React.Component {
	static contextType = ThemeContext;
	constructor(props) {
		super(props);
	}

	render() {
		if(this.props.fbPixelEnabled && this.props.shoppingCart){
			fbPixelService.trackPurchaseOrCheckout(this.props.shoppingCart, 'Purchase');
		}
		const style = {
			container: {
				flexGrow: '1',
				display: 'flex',
				flexDirection: 'column',
			},
			headline: {
				fontSize: this.context.themeManager
					.value('purchase-success', 'headlineFontSize', 'font-size-500'),
				fontWeight: '300',
				textAlign: 'center',
				margin: '0 0 1em',
			},
			headlineEventTitle: {
				fontSize: this.context.themeManager
					.value('purchase-success', 'headlineEventTitleFontSize', 'font-size-250'),
				fontWeight: '300',
				textAlign: 'center',
				margin: '0 0 0.5em',
			},
			eventTitle: {
				fontSize: this.context.themeManager
					.value('purchase-success', 'eventTitleFontSize', 'font-size-250'),
				fontWeight: '400',
				textAlign: 'center',
				margin: '0 0.5em 1.2em',
			},
			infoText: {
				margin: '2em 0 1em',
				textAlign: 'center',
				flexGrow: '1',
			},
		}
		const eventsOverviewUrl = this.context.themeManager.valueOrDefault(
			'shopping-cart', 'events-overview-url', null, 'https://leoticket.de');
		const shareUrl = (this.props.checkoutProps.output.selectedEventUuid) ? window.location.href.replace('/checkout', '') : eventsOverviewUrl;
		const shareTitel = this.props.checkoutProps.output.selectedEventUuid ?
			this.context.themeManager.getThemeText('purchaseSuccessSocialNetworkShareTitle') + this.props.checkoutProps.output.selectedEventName  :
			'';
		return (
			<div style={style.container}>
				<Image/>
				<h1
					style={style.headline}
					dangerouslySetInnerHTML={{
						__html: this.context.themeManager
							.getThemeText('purchaseSuccessHeadline'),
					}}
				/>
				<h2
					style={style.headlineEventTitle}
					dangerouslySetInnerHTML={{
						__html: this.context.themeManager
							.getThemeTextOrHardcodedDefault('purchaseSuccessHeadline2'),
					}}
				/>
				<div
					style={style.infoText}
					dangerouslySetInnerHTML={{
						__html: this.context.themeManager
							.getThemeText('purchaseSuccessInfoText'),
					}}
				/>
				<SponsorLogos />
				<ButtonEventsOverview
					btnText={this.context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
					iconName="angles-left"
				/>
				<SocialNetworks
					shareUrl={shareUrl}
					shareTitle={shareTitel}
				/>
			</div>);
	}
}

const RadiumCHECKOUT_SUCCESS = radium(CHECKOUT_SUCCESS);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
RadiumCHECKOUT_SUCCESS.name = CHECKOUT_SUCCESS.name


// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state) => {
	return {
		shoppingCart: state.shoppingCart.elements[state.merchant.merchantId],
		fbPixelEnabled: !!state.addon.fbPixelId
	}
}


export default connect(
	mapStateToProps
)(RadiumCHECKOUT_SUCCESS);
